<template>
  <div class="code-of-conduct-page">
    <PopupContainer initial-open name="code-of-conduct" class="code-of-conduct-popup" :enter-animation="false">
      <template slot="title">
        <Title title="Kodeks postępowania" reverse-colors class="contact-title" />
      </template>
      <template slot="first">
        <p>
          Zachęcamy do publikacji opinii i komentarzy na naszej stronie, a także do umieszczania odpowiednich treści wideo, zdjęć i postów. Treści te jednak nie
          mogą:
        </p>
        <ul>
          <li>Promować nadmiernego lub nieodpowiedzialnego picia napojów alkoholowych;</li>
          <li>Być obsceniczne lub w inny sposób obraźliwe, niepożądane, wulgarne, seksistowskie lub rasistowskie;</li>
          <li>Naruszać praw własności intelektualnej lub praw do prywatności innych osób lub firm;</li>
          <li>Promować lub nakłaniać do zachowań agresywnych, niebezpiecznych lub antyspołecznych;</li>
          <li>Łamać obowiązujące prawo, dobre obyczaje lub zasady społeczne; lub zawierać spam albo skutkować zakłóceniami technicznymi naszej strony;</li>
          <li>Być udostępniane osobom, które nie ukończyły 18 roku życia.</li>
        </ul>

        <p>
          Zastrzegamy sobie prawo do usunięcia według własnego uznania i bez uprzedniego powiadomienia każdego
          materiału, który nie spełnia powyższych standardów, jest nieodpowiedni lub nie spełnia Regulaminu. Nie
          ponosimy jednak odpowiedzialności za nieusunięcie lub opóźnienie w usunięciu takich materiałów. Nie wspieramy
          publikowania żadnych opinii poza tymi, które zostały przez nas opublikowane. Zachęcamy jednak do dzielenia się
          swoimi treściami i wyrażania swoich opinii. Zastrzegamy, że nie analizujemy wszystkich materiałów, jakie
          użytkownicy zamieszczają na stronie. Gorąco zachęcamy fanów naszego profilu do szanowania innych członków
          społeczności. Nasze materiały przeznaczone są dla osób powyżej 18 roku życia i nie należy ich przekazywać ani
          udostępniać osobom poniżej 18 lat. Jeśli napiszesz coś co uznane zostanie jako obraźliwe lub zamieścisz
          materiał o takim charakterze – nie zdziw się, jeśli zostanie to usunięte z naszego profilu. Podobna sytuacja
          może się zdarzyć, jeśli osoba zamieszczająca treści lub materiały na naszym profilu będzie osobą
          niepełnoletnią. Pamiętaj, aby pić piwo Królewskie odpowiedzialnie.
        </p>
      </template>
    </PopupContainer>
  </div>
</template>

<script>
import PopupContainer from '@/components/popups/PopupContainer'
import Title from '@/components/common/Title'

export default {
  components: { PopupContainer, Title },
  watch: {
    '$store.state.activePopup'(value) {
      if (value === '') {
        this.$router.push('/')
      }
    }
  },
  mounted() {
    this.$store.commit('togglePopup', 'code-of-conduct')
  }
}
</script>

<style lang="scss" scoped>
.code-of-conduct-page {
  position: relative;
  min-height: $vh;

  font-family: $light-font;
  font-size: 10px;
  line-height: 1.2em;
  letter-spacing: 0.03em;

  @include media-up(md) {
    font-size: 18px;
    line-height: 1.67em;
    letter-spacing: 0.05em;
  }
}

::v-deep .logo {
  @include media-up(lg) {
    position: absolute;
  }
}

::v-deep .popup-wrapper {
  z-index: z(code-of-conduct-popup);

  @media (max-height: 900px) {
    display: block;
  }

  @include media-down(md) {
    padding: 15px 20px 20px 15px;
  }
}

::v-deep .content--code-of-conduct {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;

  @include media-up(xxl) {
    padding-right: 6vw;
  }
}

.contact-title {
  grid-row: 1;
  grid-column: 1;

  @include media-down(lg) {
    grid-row: 1;
    grid-column: 1/ 3;
    margin-bottom: 28px;
  }
}

::v-deep .fraction--first {
  grid-row: 2;
  grid-column: 1;

  @include media-down(lg) {
    grid-row: 2;
    grid-column: 1 / 3;
  }

  @include media-up(xxl) {
    margin-right: 8.2vw;
  }
}

::v-deep .fraction--second {
  grid-row: 2;
  grid-column: 2;

  @include media-down(lg) {
    grid-row: 3;
    grid-column: 1 / 3;
    padding-top: 27px;
  }
}

.learn-more {
  margin: 32px 0 11px;
  font-family: $regular-font;
  font-size: 18px;
  line-height: 30px;
}

.link-wrapper {
  @include media-down(lg) {
    margin-bottom: 10px;
  }
}

.link {
  display: inline;
  font-family: $regular-font;
  color: $text-color;
  text-decoration: none;
  border-bottom: 1px solid $text-color;
  line-height: 2em;
  text-transform: uppercase;

  @include media-up(md) {
    border-width: 2px;
  }
}
</style>
